import Content from "../../components/home/content";
import Footer from "../../components/shared/Footer";
import Header from "../../components/shared/Header";

export default function Home() {
    return (
        <div className="flex flex-col min-h-screen">
            <main className="flex-grow">
                <Header></Header>
                <Content></Content>
            </main>
            <Footer></Footer>
        </div>
    )
}